<div class="desktop">
  <div class="container"></div>

  <div class="container">
    @if (!hideMenu) {
      <list-view-menu [options]="menuOptions" (action)="onMenu($event)"></list-view-menu>
    }
    @if (labels?.cancel?.length > 0) {
      <oph-button
        color="brown"
        appearance="outline"
        [style]="{'border-width': '0.5px', 'border-radius': '8px'}"
        [disabled]="loading"
        (click)="cancel.emit()"
      >
        {{ labels.cancel }}
      </oph-button>
    }
    <oph-button
      color="green"
      [style]="{'border-radius': '8px'}"
      [loading]="loading"
      [disabled]="loading"
      (click)="save.emit()"
    >
      {{ labels.save }}
    </oph-button>
  </div>
</div>

<div class="mobile">
  @if (!hideMenu) {
    <list-view-menu [options]="menuOptions" (action)="onMenu($event)"></list-view-menu>
  }
  @if (labels?.cancel?.length > 0) {
    <button type="button" class="mobile-button cancel-button" [disabled]="loading" (click)="cancel.emit()">
      {{ labels.cancel }}
    </button>
  }
  <button type="button" [disabled]="loading" class="mobile-button save-button" (click)="save.emit()">
    <div class="save-button-inner-container">
      @if (loading) {
        <div class="oph-white-spinner">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
      } @else {
        {{ labels.save }}
      }
    </div>
  </button>
</div>
